var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-checkin{padding:3em;margin-top:40%}.checkout{height:100vh;background:url(" + escape(require("../assets/afternoon.png")) + ")}.text-big{text-transform:uppercase;font-weight:700}.hour,.text-big{font-size:3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1751107f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Checkout.vue
// module id = Jqc/
// module chunks = 1